import React, { useState } from "react";
import emailjs from '@emailjs/browser';
import "../styles/Contact.css";

const ContactForm = () => {
  const [formData, setFormData] = useState({
    name: "",
    email: "",
    message: "",
  });
  const [status, setStatus] = useState("");

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData({
      ...formData,
      [name]: value,
    });
  };

  const handleSubmit = (e) => {
    e.preventDefault();

    emailjs
      .send(
        `${process.env.REACT_APP_EMAIL_JS_SERVICE_ID}`,
        `${process.env.REACT_APP_EMAIL_JS_TEMPLATE_ID}`,
        {
          name: e.target.name.value,
          email: e.target.email.value,
          message: e.target.message.value,
          reply_to: e.target.email.value,
        },
        {
          publicKey: `${process.env.REACT_APP_EMAIL_JS_PUBLIC_KEY}`,
        }
      )
      .then(
        (response) => {
          setStatusMessage("Message sent successfully!");
          setFormData({ name: "", email: "", message: "" });
        },
        (err) => {
          setStatusMessage("Failed to send message. Please try again.");
        },
      );
  };

  const setStatusMessage = (msg) => {
    setStatus(msg);
    setTimeout(() => {
      setStatus("");
    }, 8000);
  }

  return (
    <section className="contact-section" id="contact">
      <div className="contact-container">
        {/* Header */}
        <h2 className="contact-title">Get in Touch</h2>
        <p className="contact-subtitle">
          We would love to hear from you. Please fill out the form below or reach us directly.
        </p>

        <div className="contact-content">
          {/* Contact Information */}
          <div className="contact-us-info">
            <h1>Contact Us</h1>
            <p>
              We are committed to providing high-quality, affordable medicines, enhancing global health through innovation and patient-centered care.
            </p>
            <p>
              <strong>Address:</strong> 
                &nbsp;&nbsp;Flat - 203, Nirala Estate, Techzone - IV, <br />
                Patwari, Gautam Buddha Nagar, <br />
                Uttar Pradesh - 201113<br />
              <br />
              <strong>Phone:</strong>&nbsp;&nbsp;+91 - 8291572911<br />
              <br />
              <strong>Email:</strong>&nbsp;&nbsp;admin@orifril-lifetech.com
              <br />
            </p>
          </div>

          {/* Contact Form */}
          <div className="contact-form">
            <form onSubmit={handleSubmit}>
              <div className="form-group">
                <label htmlFor="name">Full Name</label>
                <input
                  type="text"
                  id="name"
                  name="name"
                  placeholder="Your Full Name"
                  value={formData.name}
                  onChange={handleChange}
                  required
                />
              </div>

              <div className="form-group">
                <label htmlFor="email">Email</label>
                <input
                  type="email"
                  id="email"
                  name="email"
                  placeholder="Your Email Address"
                  value={formData.email}
                  onChange={handleChange}
                  required
                />
              </div>

              <div className="form-group">
                <label htmlFor="message">Message</label>
                <textarea
                  id="message"
                  name="message"
                  placeholder="Your Message"
                  rows="5"
                  value={formData.message}
                  onChange={handleChange}
                  required
                ></textarea>
              </div>

              <button type="submit" className="submit-button">Send Message</button>
            </form>

            {/* Status Message */}
            {status && <p className="status-message">{status}</p>}
          </div>
        </div>
      </div>
    </section>
  );
};

export default ContactForm;
